import React, { useState } from 'react';
import { GraphProxy } from './graph';
import { getSettingsClass } from '~/utils/helpers';

const GraphCharts: React.FC<GraphChartsProps> = ({ block, graphData }) => {
  const settingsClass = getSettingsClass(block.settings);
  if (
    !block.graph_entries ||
    !block.graph_entries[0] ||
    !graphData ||
    !graphData.continents
  ) {
    return;
  }

  const [currentContinent, setCurrentContinent] = useState('worldwide');
  let continents: {
    label: string;
    key: string;
  }[] = [];
  const graphEntry = block.graph_entries[0];

  if ((graphEntry as PerfopsEntry).continents) {
    const blockContinents = (graphEntry as PerfopsEntry).continents;
    blockContinents.forEach(continent => {
      const continentName = graphData.continents.find(
        c => c.id === +continent
      )?.name;
      if (continentName) {
        continents.push({ label: continentName, key: continent });
      }
      if (continent === 'worldwide') {
        continents.push({ label: 'Worldwide', key: 'worldwide' });
      }
    });
  }

  const handleContinentChange =
    (continent: string) => (event: React.MouseEvent<HTMLButtonElement>) => {
      setCurrentContinent(continent);
    };

  return (
    <section className={`block block__graph ${settingsClass}`}>
      <div className='container'>
        {continents.length > 1 && (
          <div className='continents-row'>
            {continents.map(continent => {
              return (
                <button
                  type='button'
                  className={`bny-cta bny-cta--white ${continent.key === currentContinent ? 'active' : ''}`}
                  key={continent.key}
                  onClick={handleContinentChange(continent.key)}
                >
                  {continent.label}
                </button>
              );
            })}
          </div>
        )}
        <div className='row'>
          <GraphProxy
            block={block}
            data={graphData}
            continent={currentContinent}
          />
        </div>
      </div>
    </section>
  );
};

export default GraphCharts;
